/**
 * Button event options
 */
export const ButtonClickEvents = {
    left: { button: 0 },
    right: { button: 1 }
};

/**
 * Scroll event options
 */
export const ScrollEvents = {
    scrollDown: {
        target: {
            scrollHeight: 100,
            scrollTop: 100,
            offsetHeight: 0
        }
    }
};
